import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  MenuItem,
  Select,
  Switch,
  FormControlLabel,
  Typography,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import "../../../App.css";
import SearchBar from "../../SearchBar";
import { useSelector } from "react-redux";
import { postResource } from "../../../apis/apiService";
import { toast } from "react-toastify";
import {
  useFetchAddportalUserQuery,
  useFetchPortalUserQuery,
} from "../../../slice/logdetailSlice";
import { useTheme } from "../../../ThemeContext";
const PortalUserComponent = ({ onCancel, onApply, onClear }) => {
  const [search, setSearch] = useState("");
  const [roleFilter, setRoleFilter] = useState("All Roles");
  const [profileFilter, setProfileFilter] = useState("All Roles");
  const [selectedUsers, setSelectedUsers] = useState([]); // To keep track of selected users
  const [checked, setChecked] = useState(true);
  const [loading, setLoading] = useState(false);
  const { isDarkMode } = useTheme();
  const project_id = localStorage.getItem("project_id");
  // const portalUsers = useSelector(
  //   (state) => state.selectOptions.PortalUserNameOptions
  // );
  const { refetch: portal_user_detail_refetch } = useFetchPortalUserQuery(project_id);
  const portalUsers1 = useSelector(
    (state) => state.selectOptions.UserNameOptions
  );
  const { data: portalUsers, refetch: user_refetch } =
    useFetchAddportalUserQuery({
      id: project_id,
      type: "user",
    });
  // //console.log()("portalUsers using rtk query :", portalUsers);

  const userDetails = portalUsers
    ?.map((user) => {
      if (!user || !user.user_name) {
        console.warn("Invalid user data:", user);
        return null; // Skip invalid users
      }
      return {
        user_id: user.user_id,
        user_name: user.user_name.trim() || "N/A", // Replace empty names with 'N/A'
        email: user.email,
        designation: user.designation,
        role: user.role,
        image_url: user.image_url,
        rate_per_hour: user.rate_per_hour,
      };
    })
    .filter(Boolean); // Remove null values from the array

  // //console.log()("user_detail :", userDetails);
  // const filteredUsers = userDetails?.filter(
  //   (user) =>
  //     (user.user_name.toLowerCase().includes(search.toLowerCase()) ||
  //       user.email.toLowerCase().includes(search.toLowerCase()) ||
  //       user.role.toLowerCase().includes(search.toLowerCase()) ||
  //       user.designation.toLowerCase().includes(search.toLowerCase())) &&
  //     (roleFilter === "All Roles" ||
  //       user.role.toLowerCase() === roleFilter.toLowerCase())
  //   // &&
  //   // (profileFilter === "All Roles" ||
  //   //   user.designation.toLowerCase() === profileFilter.toLowerCase())
  // );
  const filteredUsers = userDetails?.filter((user) => {
    const name = user.user_name?.toLowerCase() || "";
    const email = user.email?.toLowerCase() || "";
    const role = user.role?.toLowerCase() || "";
    const designation = user.designation?.toLowerCase() || "";

    return (
      (name.includes(search.toLowerCase()) ||
        email.includes(search.toLowerCase()) ||
        role.includes(search.toLowerCase()) ||
        designation.includes(search.toLowerCase())) &&
      (roleFilter === "All Roles" || role === roleFilter.toLowerCase())
      // &&
      // (profileFilter === "All Roles" ||
      //   designation === profileFilter.toLowerCase())
    );
  });

  // Handle selection of users
  const handleUserSelect = (user, isSelected) => {
    // //console.log()("add_user : ", user, "selected :", isSelected);

    if (isSelected) {
      setSelectedUsers((prev) => [...prev, user]);
    } 
    else {
      setSelectedUsers((prev) => prev.filter((u) => u !== user));
    }
  };

  // Handle Add button click
  const handleAddClick = async () => {
    const requestedData = {
      user_ids: selectedUsers,
      notify_user: checked,
    };
    setLoading(true);
    try {
      const response = await postResource( "projects/users", "add", project_id, requestedData);
      // // //console.log()("add_user response :", response);
      if (response) {
        // //console.log()(" add_user Fetching portal users : ", response);
        toast.success(response.message);
        portal_user_detail_refetch();
        user_refetch();
        onCancel();
        // showUsers();
      }
    } 
    catch (error) {
      console.error("Error adding users to project:", error);
      toast.error(error.message);
    } 
    finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        padding: 2,
        backgroundColor: isDarkMode ? "#121212" : "#F9FAFC",
        height: "100%",
      }}
    >
      {/* Filters */}
      <Box
        sx={{
          backgroundColor: isDarkMode ? "#1e1e1e" : "white",
          padding: 2,
          borderRadius: 1,
          marginBottom: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            gap: 2,
            marginBottom: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 1,
              paddingX: 1,
            }}
          >
            <SearchBar
              placeholder="Search user name "
              onSearchChange={(e) => setSearch(e.target.value)}
            />
          </Box>
          <Select
            value={roleFilter}
            onChange={(e) => setRoleFilter(e.target.value)}
            sx={{
              color: isDarkMode ? "#fff" : "#000",
              backgroundColor: isDarkMode ? "#2e2e2e" : "#fff",
            }}
          >
            <MenuItem value="All Roles">All Roles</MenuItem>
            <MenuItem value="EMPLOYEE">Employee</MenuItem>
            <MenuItem value="Admin">Admin</MenuItem>
            <MenuItem value="Manager">Manager</MenuItem>
          </Select>
        </Box>

        {/* Table */}
        <TableContainer
          component={Paper}
          className="tableScroll"
          sx={{ backgroundColor: isDarkMode ? "#1e1e1e" : "white" }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    position: "sticky",
                    top: 0,
                    left: 0,
                    backgroundColor: isDarkMode ? "#1e1e1e" : "white",
                    zIndex: 12,
                    minWidth: 100,
                    fontWeight: 500,
                    fontSize: 15,
                    color: isDarkMode ? "#fff" : "#000",
                  }}
                >
                  Action
                </TableCell>

                <TableCell
                  sx={{
                    position: "sticky",
                    top: 0,
                    left: 100,
                    backgroundColor: isDarkMode ? "#1e1e1e" : "white",
                    zIndex: 13,
                    minWidth: 250,
                    fontWeight: 500,
                    fontSize: 15,
                    color: isDarkMode ? "#fff" : "#000",
                  }}
                >
                  User Name
                </TableCell>

                <TableCell
                  sx={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: isDarkMode ? "#1e1e1e" : "white",
                    zIndex: 10,
                    minWidth: 150,
                    fontWeight: 500,
                    fontSize: 15,
                    color: isDarkMode ? "#fff" : "#000",
                  }}
                >
                  Role
                </TableCell>

                <TableCell
                  sx={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: isDarkMode ? "#1e1e1e" : "white",
                    zIndex: 10,
                    minWidth: 150,
                    fontWeight: 500,
                    fontSize: 15,
                    color: isDarkMode ? "#fff" : "#000",
                  }}
                >
                  Profile
                </TableCell>

                <TableCell
                  sx={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: isDarkMode ? "#1e1e1e" : "white",
                    zIndex: 10,
                    minWidth: 150,
                    fontWeight: 500,
                    fontSize: 15,
                    color: isDarkMode ? "#fff" : "#000",
                  }}
                >
                  Rate Per Hour
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredUsers?.length > 0 ? (
                filteredUsers.map((user) => (
                  <TableRow key={user.user_id}>
                    <TableCell
                      sx={{
                        position: "sticky",
                        left: 0,
                        backgroundColor: isDarkMode ? "#1e1e1e" : "white",
                        zIndex: 1,
                      }}
                    >
                      <Checkbox
                        sx={{ color: isDarkMode ? "#aaa" : "#CDCDCD" }}
                        onChange={(e) =>
                          handleUserSelect(user.user_id, e.target.checked)
                        }
                      />
                    </TableCell>

                    <TableCell
                      sx={{
                        position: "sticky",
                        left: 100,
                        backgroundColor: isDarkMode ? "#1e1e1e" : "white",
                        zIndex: 1,
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: 500,
                          fontSize: 15,
                          color: isDarkMode ? "#fff" : "#000",
                        }}
                      >
                        {user.user_name}
                      </Typography>

                      <Typography
                        variant="body2"
                        sx={{ color: isDarkMode ? "#888" : "#BEBEBE" }}
                      >
                        {user.email}
                      </Typography>
                    </TableCell>

                    <TableCell
                      sx={{
                        color: isDarkMode ? "#bbb" : "#626161",
                        fontSize: 15,
                      }}
                    >
                      {user.role}
                    </TableCell>

                    <TableCell
                      sx={{
                        color: isDarkMode ? "#bbb" : "#626161",
                        fontSize: 15,
                      }}
                    >
                      {user.designation}
                    </TableCell>
                    
                    <TableCell
                      sx={{ color: isDarkMode ? "#bbb" : "#000", fontSize: 15 }}
                    >
                      INR {user.rate_per_hour}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6}>
                    <p
                      className="text-center"
                      style={{ color: isDarkMode ? "#aaa" : "#000" }}
                    >
                      User not found
                    </p>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* Add and Cancel Buttons */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          gap: "20px",
          padding: "16px 30px",
          backgroundColor: isDarkMode ? "#1e1e1e" : "#f9f9f9",
          borderTop: "1px solid #ddd",
          position: "absolute",
          bottom: -10,
          width: "100%",
          zIndex: 100,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <button
            className="add_btn"
            onClick={handleAddClick}
            disabled={selectedUsers.length === 0 || loading}
          >
            {loading ? "Adding..." : "Add"}
          </button>
          <button
            className="cancel_btn mx-3"
            disabled={loading}
            onClick={onCancel}
          >
            Cancel
          </button>
        </Box>
        <Box>
          <FormControlLabel
            control={
              <Switch
                checked={checked}
                onChange={(e) => setChecked(e.target.checked)}
              />
            }
          />
        </Box>
      </Box>
    </Box>
  );
};

export default PortalUserComponent;
